import { RadioOption } from "@/forms/components";

// -- Landvalg ----------------------------------------------------------------

export const COUNTRY_OPTIONS: RadioOption[] = [
  { label: "Norge", value: "NO" },
  { label: "Sverige", value: "SE" },
  { label: "Finland", value: "FI" },
  { label: "USA", value: "US" },
  { label: "Canada", value: "CA" },
  { label: "Danmark", value: "DK" },
  { label: "Sveits", value: "CH" },
  { label: "Nederland", value: "NL" },
  { label: "Island", value: "IS" },
  { label: "Luxemburg", value: "LU" },
  { label: "Frankrike", value: "FR" },
  { label: "Spania", value: "ES" },
  { label: "Storbritannia", value: "GB" },
  { label: "Portugal", value: "PT" },
  { label: "Sor-Afrika", value: "ZA" },
  { label: "Tyskland", value: "DE" },
  { label: "Thailand", value: "TH" },
];

// -- Personopplysninger ------------------------------------------------------

export const PEP_OPTIONS: RadioOption[] = [
  { label: "Ja", value: "other" },
  { label: "Nei", value: "Nei" },
];

export const NET_WEALTH_OPTIONS: RadioOption[] = [
  { label: "0–5 MNOK", value: "0-5 MNOK" },
  { label: "5–10 MNOK", value: "5-10 MNOK" },
  { label: "10–25 MNOK", value: "10-25 MNOK" },
  { label: "25–100 MNOK", value: "25-100 MNOK" },
  { label: "> 100 MNOK", value: ">100 MNOK" },
];

export const GROSS_ANNUAL_INCOME_OPTIONS: RadioOption[] = [
  { label: "0–1 MNOK", value: "0-1 MNOK" },
  { label: "1–2 MNOK", value: "1-2 MNOK" },
  { label: "2,5–5 MNOK", value: "2.5-5 MNOK" },
  { label: "> 5 MNOK", value: ">5 MNOK" },
];

export const LIQUIDITY_BUFFER_OPTIONS: RadioOption[] = [
  { label: "< 250K", value: "<250K" },
  { label: "250K–1 MNOK", value: "250K-1 MNOK" },
  { label: "1–3 MNOK", value: "1-3 MNOK" },
  { label: "> 3 MNOK", value: ">3 MNOK" },
];

// -- AML/KYC -----------------------------------------------------------------

export const EMPLOYMENT_OPTIONS: RadioOption[] = [
  { label: "I arbeid", value: "I arbeid" },
  {
    label: "Eier og driver egen virksomhet",
    value: "Eier og driver egen virksomhet",
  },
  { label: "Pensjonist", value: "Pensjonist" },
  { label: "Okonomisk uavhengig", value: "Okonomisk uavhengig" },
  { label: "Annet", value: "other" },
];

export const PRIV_PURPOSE_OPTIONS: RadioOption[] = [
  { label: "Investeringer", value: "Investeringer" },
  { label: "Annet", value: "other" },
];

export const PORTFOLIO_SIZE_OPTIONS: RadioOption[] = [
  { label: "0 til 5 MNOK", value: "0 til 5 MNOK" },
  { label: "5 til 10 MNOK", value: "5 til 10 MNOK" },
  { label: "10 til 25 MNOK", value: "10 til 25 MNOK" },
  { label: "Mer enn 25 MNOK", value: "Mer enn 25 MNOK" },
];

export const ANNUAL_DEPOSITS_OPTIONS: RadioOption[] = [
  { label: "Mindre enn 10", value: "Mindre enn 10" },
  { label: "10-50", value: "10-50" },
  { label: "Mer enn 50", value: "Mer enn 50" },
];

export const PRIV_SOURCE_OF_FUNDS_OPTIONS: RadioOption[] = [
  { label: "Lonn", value: "Lonn" },
  {
    label: "Naeringsinntekt / Leieinntekt",
    value: "Naeringsinntekt / Leieinntekt",
  },
  { label: "Andre investeringer", value: "Andre investeringer" },
  { label: "Arv / Gave", value: "Arv / Gave" },
  { label: "Annet", value: "other" },
];

export const PRIV_SOURCE_OF_WEALTH_OPTIONS: RadioOption[] = [
  { label: "Oppsparing av lønn", value: "Oppsparing av lønn" },
  { label: "Salg av virksomhet", value: "Salg av virksomhet" },
  { label: "Salg av eiendom", value: "Salg av eiendom" },
  { label: "Arv/gave", value: "Arv/gave" },
  { label: "Gevinst investeringer", value: "Gevinst investeringer" },
  { label: "Utbytte", value: "Utbytte" },
  { label: "Lån", value: "Lån" },
  { label: "Annet", value: "other" },
];

/** Nei/Ja (Ja = "other") */
export const NO_YES_OTHER_OPTIONS: RadioOption[] = [
  { label: "Nei", value: "Nei" },
  { label: "Ja", value: "other" },
];

export const CRYPTO_OPTIONS: RadioOption[] = [
  { label: "Nei", value: "Nei" },
  { label: "Ja", value: "Ja" },
];

export const DEBT_BURDEN_OPTIONS: RadioOption[] = [
  { label: "Lav (<30%)", value: "Lav" },
  { label: "Moderat (30-60%)", value: "Moderat" },
  { label: "Høy (>60%)", value: "Høy" },
];

// -- Shared MiFID options (also re-exported by KycOrgForm.options.ts) --------

export const MIFID_INSTRUMENT_ROWS = [
  {
    label: "Verdipapirfond",
    knowledgeField: "mifidKnowledgeOfMutualFunds" as const,
    experienceField: "mifidExperienceOfMutualFunds" as const,
    tradingFrequencyField: "mifidTradingFrequencyOfMutualFunds" as const,
    periodField: "mifidPeriodOfMutualFunds" as const,
  },
  {
    label: "Borsnoterte aksjer",
    knowledgeField: "mifidKnowledgeOfListedStocks" as const,
    experienceField: "mifidExperienceOfListedStocks" as const,
    tradingFrequencyField: "mifidTradingFrequencyOfListedStocks" as const,
    periodField: "mifidPeriodOfListedStocks" as const,
  },
  {
    label: "Unoterte aksjer",
    knowledgeField: "mifidKnowledgeOfUnlistedStocks" as const,
    experienceField: "mifidExperienceOfUnlistedStocks" as const,
    tradingFrequencyField: "mifidTradingFrequencyOfUnlistedStocks" as const,
    periodField: "mifidPeriodOfUnlistedStocks" as const,
  },
  {
    label: "Obligasjoner",
    knowledgeField: "mifidKnowledgeOfBonds" as const,
    experienceField: "mifidExperienceOfBonds" as const,
    tradingFrequencyField: "mifidTradingFrequencyOfBonds" as const,
    periodField: "mifidPeriodOfBonds" as const,
  },
  {
    label: "Komplekse investeringer",
    knowledgeField: "mifidKnowledgeOfComplexInvestments" as const,
    experienceField: "mifidExperienceOfComplexInvestments" as const,
    tradingFrequencyField: "mifidTradingFrequencyOfComplexInvestments" as const,
    periodField: "mifidPeriodOfComplexInvestments" as const,
  },
] as const;

export const TRADING_FREQUENCY_COLUMNS = [
  { label: "0", value: "1" },
  { label: "1-2 pr \u00e5r", value: "2" },
  { label: "3-10 pr \u00e5r", value: "3" },
  { label: "Mer enn 10 pr \u00e5r", value: "4" },
];

export const PERIOD_COLUMNS = [
  { label: "Mindre enn 1 \u00e5r", value: "1" },
  { label: "1-3 \u00e5r", value: "2" },
  { label: "3-5 \u00e5r", value: "3" },
  { label: "Mer enn 5 \u00e5r", value: "4" },
];

export const MIFID_EXPERIENCE_EDUCATION_OPTIONS: RadioOption[] = [
  { label: "Ingen relevant erfaring eller utdanning", value: "1" },
  { label: "Noe erfaring fra finansielle markeder", value: "2" },
  { label: "Relevant utdanning innen finans/okonomi", value: "3" },
  { label: "Yrkeserfaring fra finansbransjen", value: "4" },
];

export const KNOWLEDGE_COLUMNS = [
  { label: "Lav", value: "1" },
  { label: "Medium", value: "2" },
  { label: "Høy", value: "3" },
];

export const EXPERIENCE_COLUMNS = [
  { label: "Ingen", value: "1" },
  { label: "Noe", value: "2" },
  { label: "Betydelig", value: "3" },
];

export const ESG_PREF_OPTIONS: RadioOption[] = [
  { label: "Ja", value: "Ja" },
  {
    label: "Nei, jeg følger Capguards generelle vurderinger på dette området",
    value: "Nei",
  },
];

export const ESG_PREF_TYPE_OPTIONS: RadioOption[] = [
  {
    label: "Preferanse 1 – Bærekraftige investeringer (SFDR art. 8/9)",
    value: "1",
  },
  { label: "Preferanse 2 – EU-taksonomi-tilpassede investeringer", value: "2" },
  {
    label: "Preferanse 3 – Hensyn til negative bærekraftsvirkninger (PAI)",
    value: "3",
  },
  { label: "Preferanse 4 – Kombinasjon av preferansene over", value: "4" },
];

// -- Shared suitability options (also used by KycOrgForm.options.ts) ---------

export const INCOME_STABILITY_OPTIONS: RadioOption[] = [
  { label: "Helt stabil", value: "1" },
  { label: "Noe variabel (pluss/minus 20 %)", value: "2" },
  { label: "Ganske variabel (pluss/minus 50 %)", value: "3" },
  { label: "Helt variabel", value: "5" },
];

export const INVESTMENT_HORIZON_OPTIONS: RadioOption[] = [
  { label: "Under ett år", value: "1" },
  { label: "Fra 1–5 år", value: "2" },
  { label: "Mer enn 5 år", value: "3" },
  { label: "Mer enn 15 år / Generasjonsforvaltning", value: "5" },
];

export const INVESTMENT_GOAL_OPTIONS: RadioOption[] = [
  { label: "Kapitalbevaring", value: "1" },
  { label: "Stabil avkastning", value: "2" },
  { label: "Moderat vekst", value: "3" },
  { label: "Langsiktig vekst", value: "4" },
];

export const RISK_COMFORT_OPTIONS: RadioOption[] = [
  { label: "Lav", value: "1" },
  { label: "Moderat", value: "2" },
  { label: "Høy", value: "3" },
  { label: "Offensiv", value: "4" },
];

export const MARKET_DROP_RESPONSE_OPTIONS: RadioOption[] = [
  {
    label: "Selge hele eller deler av porteføljen for å redusere risiko",
    value: "Selge hele eller deler av porteføljen for å redusere risiko",
  },
  {
    label: "Beholde porteføljen og avvente utviklingen",
    value: "Beholde porteføljen og avvente utviklingen",
  },
  {
    label:
      "Vurdere å investere mer eller rebalansere porteføljen for å utnytte lavere priser",
    value:
      "Vurdere å investere mer eller rebalansere porteføljen for å utnytte lavere priser",
  },
];

export const INVESTMENT_EXPERIENCE_OPTIONS: RadioOption[] = [
  { label: "Lav", value: "1" },
  { label: "Moderat", value: "2" },
  { label: "Høy", value: "3" },
  { label: "Svært høy", value: "4" },
];

export const VALUE_DECLINE_IMPACT_OPTIONS: RadioOption[] = [
  { label: "Lav", value: "Lav" },
  { label: "Moderat", value: "Moderat" },
  { label: "Høy", value: "Høy" },
  { label: "Svært høy", value: "Svært høy" },
];

export const MARKET_FALL_OPTIONS: RadioOption[] = [
  { label: "Jeg ville sannsynligvis selge for a redusere tapet.", value: "1" },
  { label: "Jeg ville gjore ingenting og vente pa oppgang.", value: "2" },
  {
    label: "Jeg ville vurdere a kjope mer for a utnytte de lave prisene.",
    value: "3",
  },
  {
    label:
      "Jeg ville bruke markedsfallet strategisk til a rebalansere og oke eksponeringen i billigere aktiva.",
    value: "4",
  },
];

export const LIQUIDITY_OPTIONS: RadioOption[] = [
  { label: "Svært viktig", value: "1" },
  { label: "Viktig", value: "2" },
  { label: "Lite viktig", value: "3" },
  { label: "Ikke viktig", value: "4" },
];
